import React from 'react';
import { GroupBase, InputProps, components as ReactSelectComponents } from 'react-select';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  onInputFocus?: (event: React.FocusEvent<HTMLInputElement>) => void,
  ownProps: InputProps<SOption, IsMulti, Group>,
  name?: string,
}

const Input = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  name,
  onInputFocus,
  ownProps,
}: IProps<SOption, IsMulti, Group>) => (
  <ReactSelectComponents.Input
    { ...ownProps }
    name={ name }
    onFocus={ (event) => {
      if (typeof onInputFocus === 'function') {
        onInputFocus(event);
      }

      ownProps.onFocus(event);
    } }
    data-lpignore
  />
);

export default Input;
